/**
 * @file お気に入り店舗追加
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname AddFavoriteShop
 * @classdesc お気に入り店舗追加
 */
export default class AddFavoriteShop {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-order-confirm
	 */
	constructor($e) {
		console.log('AddFavoriteShop.constructor');
		// ログインしていたら実施しない
		if($('.header').hasClass('logined')) return;
		let shopSelected = window.localStorage.getItem('_cfs_') || null;
		shopSelected = JSON.parse(shopSelected);
		const shopId = shopSelected.shopId;
		if(shopSelected && shopId){
			document.cookie = `my_shop=${shopId};path=/`;
		}
	};
}
